(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/components/billing-information/constants.js');

const names = {
  REFERENCE: 'reference',
  INVOICE_MESSAGE: 'invoiceMessage',
  MESSAGE: 'message'
};

const TEXTS = {
  HEADER: 'Faktureringsadress',
  REFERENCE: {
    LABEL: 'Referens (Person, avd, etc.)',
    MAX: 150,
    MAX_ERROR: 'Fältet får inte innehålla mer än 150 tecken',
    REQUIRED_ERROR: 'Du måste ange en referens'
  },
  MESSAGE: {
    LABEL: 'Eget meddelande till Svenska Spel (valfritt)',
    MAX: 500,
    MAX_ERROR: '',
    ROWS: 4
  },
  INVOICE_MESSAGE: {
    LABEL: 'Eget meddelande på fakturan (valfritt)',
    MAX: 500,
    MAX_ERROR: '',
    ROWS: 4
  }
};

svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.constants = {
  TEXTS,
  names
};


 })(window);